const highestWager = 50;

export const calculateTopPrizeMultipier = (topPrize: number) => topPrize / highestWager;
